var Color;

(function (Color2) {
  Color2["Accent"] = "accent";
  Color2["Brand"] = "brand";
  Color2["Bg"] = "bg";
  Color2["Bg2"] = "bg-2";
  Color2["Bg3"] = "bg-3";
  Color2["Bg4"] = "bg-4";
  Color2["BgAlt"] = "bg-alt";
  Color2["BgLight"] = "bg-light";
  Color2["Invert"] = "invert";
  Color2["TextHover"] = "text-hover";
  Color2["TextTitle"] = "text-title";
  Color2["TextCaption"] = "text-caption";
  Color2["TextBody"] = "text-body";
  Color2["Icon"] = "icon";
  Color2["InputPlaceholder"] = "input-placeholder";
  Color2["Border"] = "border";
  Color2["FeedbackAlert"] = "feedback-alert";
  Color2["FeedbackError"] = "feedback-error";
  Color2["FeedbackSuccess"] = "feedback-success";
})(Color || (Color = {}));

export { Color };
//# sourceMappingURL=color-modes.esm.js.map
